export default "__VITE_ASSET__D6XRl_7H__"